export default "__VITE_ASSET__CUGt_yBG__"